export enum legal {
  'en-US' = 'Cowbell Insurance Agency LLC, CDI License #0N04366',
  'en-GB' = 'Cowbell Managing General Agency Ltd Company Number 14570024',
  'en-AU' = 'Cowbell Insurance Solutions Pty Ltd ABN 52 684 362 552',
}
